function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "bsPrefix",
    "className",
    "as"
];
import classNames from 'classnames';
import React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
var DEVICE_SIZES = [
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
var Col = /*#__PURE__*/ React.forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    var prefix = useBootstrapPrefix(bsPrefix, 'col');
    var spans = [];
    var classes = [];
    DEVICE_SIZES.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var span;
        var offset;
        var order;
        if ((typeof propValue === "undefined" ? "undefined" : _type_of(propValue)) === 'object' && propValue != null) {
            var _propValue$span = propValue.span;
            span = _propValue$span === void 0 ? true : _propValue$span;
            offset = propValue.offset;
            order = propValue.order;
        } else {
            span = propValue;
        }
        var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
        if (span) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
        if (order != null) classes.push("order" + infix + "-" + order);
        if (offset != null) classes.push("offset" + infix + "-" + offset);
    });
    if (!spans.length) {
        spans.push(prefix); // plain 'col'
    }
    return /*#__PURE__*/ React.createElement(Component, _extends({}, props, {
        ref: ref,
        className: classNames.apply(void 0, [
            className
        ].concat(spans, classes))
    }));
});
Col.displayName = 'Col';
export default Col;
